import React, { useEffect, useState } from "react";
import {
  getSingleSurvey,
  surveyResultPreview,
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Button, Snackbar } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import Input from "../../../atoms/Input";
import TextArea from "../../../atoms/Textarea";
import ContactDetailField from "../../../molecules/ContactDetailField";
import { useLocation } from "react-router-dom";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonIcon from "@mui/icons-material/Person";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import GavelIcon from "@mui/icons-material/Gavel";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PrintComponent from "../../PrintComponent";
import QuotationFormDownload from "./download";
import moment from "moment";
import MySignatureCanvas from "../../../molecules/signature_canvas";

const ClientQuote = () => {
  const [formContent, setFormContent] = useState({});
  const [formContentId, setFormContentId] = useState("");

  const [surveyData, setSurveyData] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [isSignCanvas, setSignCanvas] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");



  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const updateContent = (data, md) => {
    setIsLoading(true);

    let media = [];
    if (formContent?.clientSign != "") media[0] = formContent?.clientSign;

    const body = {
      formContentId: formContentId,
      content: data ? data : formContent,
      mediaKeys: md,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        setSnackbarMessage("Quotation Form has been accepted successfully!");

        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
        setUploadText("Upload Signature & Quote Acceptance");
        setMediaKeysToSend([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }
        setUploadText("Upload Signature & Quote Acceptance");
        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    setMediaKeysToSend([]);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
      })
      .catch((error) => {
        setIsValid(false);
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);




  const [uploadText, setUploadText] = useState(
    "Upload Signature & Quote Acceptance"
  );
  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);
  //
  const uploadFile = async (file) => {
    setIsLoading(true);

    setUploadText("Uploading...");
    const fd = new FormData();
    fd.append("image", file);

    imageUploadClientPreview(fd, surveyId, formId, email, token)
      .then((res) => {
        let values = { ...formContent };
        values.clientSign = res?.data?.data?.key;
        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setTimeout(() => {
          updateContent(values, md);
        }, 1500);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setUploadText("Upload Signature & Quote Acceptance");

        setIsLoading(false);
      });
  };



  let movableItems = 0;
  let nonmovableItems = 0;

  //
  const getSurvey = () => {
    getSingleSurvey(surveyId)
      .then((response) => {
        // if (response?.data?.data?.status == "submitted") getSurveyPreview();
        // else {
        setSurveyData(response?.data?.data);
        // }
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }
      });
  };

  //


  useEffect(() => {
    getSurvey();
  }, []);



  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Helper function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  return (
    <>
      {isValid ? (
        <PremiumPublicLayout
            title="Quotation"
            hideBackButton={true}
             actions={
                <div className="d-flex gap-3">
                     {formContent?.clientSign?.trim()?.length == 0 && (
                        <Button
                            variant="contained"
                            onClick={() => setSignCanvas(true)}
                            sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                        >
                            {uploadText}
                        </Button>
                    )}

                    <Button
                        variant="contained"
                        onClick={() => {
                            if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                      setIsLoading(true);
                            var tempTitle = document.title;
                            document.title = `Quotation-${formContent?.to}-${moment(
                                new Date()
                            ).format("DD.MM.YYYY")}`;

                            window.print();
                            document.title = tempTitle;
                            setIsLoading(false);
                        }}
                        disabled={isLoading}
                        sx={{ 
                            textTransform: "none", 
                            borderRadius: "var(--radius-md)", 
                            padding: "10px 24px",
                            fontWeight: 700,
                            backgroundColor: "var(--text-main)",
                            boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                            '&:hover': { backgroundColor: '#000' }
                        }}
                        startIcon={<DescriptionIcon />}
                    >
                        Save as PDF
                    </Button>
                </div>
            }
        >
              <PremiumCard sx={{ marginBottom: "32px" }}>
                 <SectionHeader title="Customer Details" icon={<PersonIcon />} />
                 <Row>
                     <Col md={6}>
                        <ContactDetailField
                            label="To"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"150px"}
                            value={formContent?.to}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.to = e.target.value;
                                setFormContent(values);
                            }}
                        />
                         <ContactDetailField
                            label="Location"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"150px"}
                            value={formContent?.location}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.location = e.target.value;
                                setFormContent(values);
                            }}
                        />
                         <ContactDetailField
                            label="Email"
                            isEdit={isEdit}
                            type="email"
                            minWidth={"150px"}
                            value={formContent?.email}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.email = e.target.value;
                                setFormContent(values);
                            }}
                        />
                     </Col>
                     <Col md={6}>
                        <ContactDetailField
                            label="Date"
                            isEdit={isEdit}
                            type="date"
                            minWidth={"150px"}
                            value={formContent?.date}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.date = e.target.value;
                                setFormContent(values);
                            }}
                        />
                         <ContactDetailField
                            label="Tel"
                            isEdit={isEdit}
                            type="number"
                            minWidth={"150px"}
                            value={formContent?.phoneNo}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.phoneNo = e.target.value;
                                setFormContent(values);
                            }}
                        />
                     </Col>
                 </Row>
                 <hr style={{margin: '20px 0', borderColor: '#eee'}}/>
                  <Row>
                      <Col md={12}>
                        <label
                        htmlFor="to"
                        className={`fw-bold ${isEdit ? "mb-3" : "mb-1"}`}
                        style={{display: 'block'}}
                        >
                        Dear {formContent?.recipient},
                        </label>
                        {!isEdit ? (
                        <p>{formContent?.details ? formContent?.details : "-"}</p>
                        ) : (
                        <TextArea
                            rows="3"
                            label="Details here..."
                            id="description"
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.details = e.target.value;
                            setFormContent(values);
                            }}
                            value={formContent?.details}
                        />
                        )}
                      </Col>
                  </Row>
             </PremiumCard>

              <PremiumCard sx={{ marginBottom: "32px" }}>
                 <SectionHeader title="Service & Route" icon={<LocalShippingIcon />} />
                 <Row>
                     <Col md={6}>
                         <div className="mb-3">
                            <label className="fw-bold mb-1 d-block">Service Required</label>
                             {!isEdit ? (
                                <span>{formContent?.serviceRequired || "-"}</span>
                             ) : (
                                <TextArea
                                    rows="2"
                                    value={formContent?.serviceRequired}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.serviceRequired = e.target.value;
                                        setFormContent(values);
                                    }}
                                />
                             )}
                         </div>
                         <div className="mb-3">
                            <label className="fw-bold mb-1 d-block">Tentative/Requested Packing Date</label>
                             {!isEdit ? (
                                <span>{formContent?.packingDate ? formatDate(formContent?.packingDate) : "-"}</span>
                             ) : (
                                <Input
                                    type="date"
                                    value={formContent?.packingDate}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.packingDate = e.target.value;
                                        setFormContent(values);
                                    }}
                                />
                             )}
                         </div>
                         <div className="mb-3">
                            <label className="fw-bold mb-1 d-block">Transportation Mode</label>
                             {!isEdit ? (
                                <span>{formContent?.transportationMode || "-"}</span>
                             ) : (
                                <Input
                                    type="text"
                                    value={formContent?.transportationMode}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.transportationMode = e.target.value;
                                        setFormContent(values);
                                    }}
                                />
                             )}
                         </div>
                     </Col>
                     <Col md={6}>
                         <div className="mb-3">
                            <label className="fw-bold mb-1 d-block">Origin Address</label>
                             {!isEdit ? (
                                <span>{formContent?.originAddress || "-"}</span>
                             ) : (
                                <TextArea
                                    rows="2"
                                    value={formContent?.originAddress}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.originAddress = e.target.value;
                                        setFormContent(values);
                                    }}
                                />
                             )}
                         </div>
                         <div className="mb-3">
                            <label className="fw-bold mb-1 d-block">Destination Address</label>
                             {!isEdit ? (
                                <span>{formContent?.destinationAddress || "-"}</span>
                             ) : (
                                <TextArea
                                    rows="2"
                                    value={formContent?.destinationAddress}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.destinationAddress = e.target.value;
                                        setFormContent(values);
                                    }}
                                />
                             )}
                         </div>
                     </Col>
                 </Row>
             </PremiumCard>

              <PremiumCard sx={{ marginBottom: "32px" }}>
                 <SectionHeader title="Cargo & Charges" icon={<MonetizationOnIcon />} />
                 <Row>
                     <Col md={12} className="mb-3">
                        <label className="fw-bold mb-1 d-block">Description</label>
                             {!isEdit ? (
                                <span>{formContent?.description || "-"}</span>
                             ) : (
                                <TextArea
                                    rows="3"
                                    value={formContent?.description}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.description = e.target.value;
                                        setFormContent(values);
                                    }}
                                />
                             )}
                     </Col>
                 </Row>
                 <Row>
                     <Col md={4} className="mb-3">
                        <label className="fw-bold mb-1 d-block">Estimated Weight</label>
                             {!isEdit ? (
                                <span>{formContent?.estimatedWeight || "-"}</span>
                             ) : (
                                <Input
                                    type="text"
                                    value={formContent?.estimatedWeight}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.estimatedWeight = e.target.value;
                                        setFormContent(values);
                                    }}
                                />
                             )}
                     </Col>
                     <Col md={4} className="mb-3">
                         <label className="fw-bold mb-1 d-block">Estimated Volume</label>
                             {!isEdit ? (
                                <span>
                                    {formContent?.estimatedVolume ? (
                                    <>
                                        {Number(formContent?.estimatedVolume)?.toFixed(2)} m{" "}
                                        <sup>3</sup>{" "}
                                    </>
                                    ) : (
                                    "-"
                                    )}
                                </span>
                             ) : (
                                <Input
                                    type="text"
                                    value={formContent?.estimatedVolume}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.estimatedVolume = e.target.value;
                                        setFormContent(values);
                                    }}
                                />
                             )}
                     </Col>
                     <Col md={4} className="mb-3">
                         <label className="fw-bold mb-1 d-block">Complete Charges</label>
                             {!isEdit ? (
                                <span style={{fontSize: '1.1rem', fontWeight: 'bold', color: '#1976d2'}}>
                                    {formContent?.charges || "-"}
                                </span>
                             ) : (
                                <Input
                                    type="number"
                                    value={formContent?.charges}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.charges = e.target.value;
                                        setFormContent(values);
                                    }}
                                />
                             )}
                     </Col>
                 </Row>
             </PremiumCard>

              <PremiumCard sx={{ marginBottom: "32px" }}>
                 <SectionHeader title="Terms & Conditions" icon={<GavelIcon />} />
                 <Row>
                     <Col md={6} className="mb-3">
                        <label className="fw-bold mb-1 d-block">Quote Validity</label>
                             {!isEdit ? (
                                <span>{formContent?.quoteValidity || "-"}</span>
                             ) : (
                                <TextArea rows="2" value={formContent?.quoteValidity} onChange={(e) => {let values = {...formContent}; values.quoteValidity = e.target.value; setFormContent(values);}} />
                             )}
                     </Col>
                     <Col md={6} className="mb-3">
                        <label className="fw-bold mb-1 d-block">Insurance</label>
                             {!isEdit ? (
                                <span>{formContent?.insurance || "-"}</span>
                             ) : (
                                <TextArea rows="2" value={formContent?.insurance} onChange={(e) => {let values = {...formContent}; values.insurance = e.target.value; setFormContent(values);}} />
                             )}
                     </Col>
                     <Col md={6} className="mb-3">
                        <label className="fw-bold mb-1 d-block">Price Include at Origin</label>
                             {!isEdit ? (
                                <span>{formContent?.priceIncludeAtOrigin || "-"}</span>
                             ) : (
                                <TextArea rows="3" value={formContent?.priceIncludeAtOrigin} onChange={(e) => {let values = {...formContent}; values.priceIncludeAtOrigin = e.target.value; setFormContent(values);}} />
                             )}
                     </Col>
                     <Col md={6} className="mb-3">
                        <label className="fw-bold mb-1 d-block">Standard Exclusions</label>
                             {!isEdit ? (
                                <span>{formContent?.standardExclusions || "-"}</span>
                             ) : (
                                <TextArea rows="3" value={formContent?.standardExclusions} onChange={(e) => {let values = {...formContent}; values.standardExclusions = e.target.value; setFormContent(values);}} />
                             )}
                     </Col>
                     <Col md={6} className="mb-3">
                        <label className="fw-bold mb-1 d-block">Documents Required</label>
                             {!isEdit ? (
                                <span>{formContent?.documentsRequired || "-"}</span>
                             ) : (
                                <TextArea rows="3" value={formContent?.documentsRequired} onChange={(e) => {let values = {...formContent}; values.documentsRequired = e.target.value; setFormContent(values);}} />
                             )}
                     </Col>
                     <Col md={6} className="mb-3">
                        <label className="fw-bold mb-1 d-block">Payment Terms</label>
                             {!isEdit ? (
                                <span>{formContent?.paymentTerms || "-"}</span>
                             ) : (
                                <TextArea rows="3" value={formContent?.paymentTerms} onChange={(e) => {let values = {...formContent}; values.paymentTerms = e.target.value; setFormContent(values);}} />
                             )}
                     </Col>
                 </Row>
             </PremiumCard>

              <PremiumCard sx={{ marginBottom: "32px" }}>
                 <SectionHeader title="Bank Details" icon={<AccountBalanceIcon />} />
                 <Row>
                     <Col md={6}>
                        <ContactDetailField
                            label="IBAN No"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"150px"}
                            value={formContent?.bankDetails?.iban}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.bankDetails.iban = e.target.value;
                                setFormContent(values);
                            }}
                        />
                         <ContactDetailField
                            label="Account Title"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"150px"}
                            value={formContent?.bankDetails?.title}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.bankDetails.title = e.target.value;
                                setFormContent(values);
                            }}
                        />
                     </Col>
                     <Col md={6}>
                        <ContactDetailField
                            label="Swift Code"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"150px"}
                            value={formContent?.bankDetails?.swiftCode}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.bankDetails.swiftCode = e.target.value;
                                setFormContent(values);
                            }}
                        />
                         <ContactDetailField
                            label="Branch Name & Code"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"150px"}
                            value={formContent?.bankDetails?.branchNameCode}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.bankDetails.branchNameCode = e.target.value;
                                setFormContent(values);
                            }}
                        />
                     </Col>
                 </Row>
             </PremiumCard>

            <PremiumCard>
                <SectionHeader title="Signatures" icon={<DescriptionIcon />} />
                <Row className="mb-4">
                     <Col sm={6} className="text-center">
                         <div
                            style={{ height: "90px" }}
                            className="d-flex justify-content-center align-items-end"
                        >
                            {formContent.clientSign !== "" &&
                            formContent.clientSign !== undefined && (
                                <img
                                alt = ""
                                src={`${Bucket}${formContent.clientSign}`}
                                height={80}
                                width={200}
                                style={{maxHeight: '80px', maxWidth: '100%', objectFit: 'contain'}}
                                />
                            )}
                        </div>
                         <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                         <p className="my-1">
                            <b>{"QUOTATION Acceptance"}</b>
                        </p>
                    </Col>
                     <Col sm={6} className="text-center">
                         <div
                            style={{ height: "90px" }}
                            className="d-flex justify-content-center align-items-end"
                        >
                            {formContent?.adminSign?.trim()?.length === 0 ? (
                            <div className="d-flex justify-content-center align-items-end"></div>
                            ) : (
                            <img
                                alt=""
                                src={`${Bucket}${formContent.adminSign}`}
                                height={80}
                                width={200}
                                style={{maxHeight: '80px', maxWidth: '100%', objectFit: 'contain'}}
                            />
                            )}
                        </div>
                        <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                        <p className="my-1">
                            <b>{"Shelozon Movers Packers & Logistics Pvt Ltd"}</b>
                        </p>
                    </Col>
                </Row>
             </PremiumCard>
        </PremiumPublicLayout>
      ) : (
        <>
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </>
      )}

      <PrintComponent>
        <QuotationFormDownload
          id="content-id"
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      {/* Add signature Modal */}
      {isSignCanvas && (
        <MySignatureCanvas
          open={isSignCanvas}
          onClose={() => {
            setSignCanvas(false);
          }}
          onSuccess={(file) => {
            if (!isLoading) uploadFile(file);
          }}
        />
      )}
    </>
  );
};
export default ClientQuote;
